var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCircleUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#D1FADF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10253_190172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4688 18.8438V17.9062C17.4688 17.409 17.2712 16.9321 16.9196 16.5804C16.5679 16.2288 16.091 16.0312 15.5938 16.0312H11.8438C11.3465 16.0312 10.8696 16.2288 10.5179 16.5804C10.1663 16.9321 9.96875 17.409 9.96875 17.9062V18.8438M20.2812 18.8438V17.9062C20.2809 17.4908 20.1427 17.0872 19.8881 16.7589C19.6336 16.4306 19.2772 16.196 18.875 16.0922M17 10.4672C17.4033 10.5705 17.7608 10.805 18.0161 11.1339C18.2714 11.4628 18.4099 11.8673 18.4099 12.2836C18.4099 12.6999 18.2714 13.1044 18.0161 13.4333C17.7608 13.7622 17.4033 13.9967 17 14.1M15.5938 12.2812C15.5938 13.3168 14.7543 14.1562 13.7188 14.1562C12.6832 14.1562 11.8438 13.3168 11.8438 12.2812C11.8438 11.2457 12.6832 10.4062 13.7188 10.4062C14.7543 10.4062 15.5938 11.2457 15.5938 12.2812Z",
    stroke: "#039855",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10253_190172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.25,
    height: 11.25,
    fill: "white",
    transform: "translate(9.5 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircleUser);
export default __webpack_public_path__ + "static/media/green_circle_user.79e8438daf8cf9c022db9e28e511bc1f.svg";
export { ForwardRef as ReactComponent };